import getWithToken from './base/get-with-token'

const getCustomerGroupUsage = (id, params = {}) =>
  getWithToken(`/customer-group/${id}/usage`)(params)

export default getCustomerGroupUsage
